import { render, staticRenderFns } from "./tissue.vue?vue&type=template&id=deae6b08&scoped=true&"
import script from "./tissue.vue?vue&type=script&lang=js&"
export * from "./tissue.vue?vue&type=script&lang=js&"
import style0 from "./tissue.vue?vue&type=style&index=0&id=deae6b08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deae6b08",
  null
  
)

export default component.exports